const panels = document.querySelectorAll('.side-panel__categ_1>.side-panel__categ-toggle');
const panels_niv2 = document.querySelectorAll('.side-panel__categ_2>.side-panel__categ-toggle');
const $toggle_button = document.querySelector('.side-panel__toggle-results');

$toggle_button.addEventListener('click', function() {
    $toggle_button.classList.toggle('side-panel__toggle-results--active');
    document.querySelector('.side-panel').classList.toggle('side-panel--fully-opened');
});

Array.prototype.forEach.call(panels,function(el){
    // Premier Niveau
    el.addEventListener('click',function(){
        //console.log('niv1');
        Array.prototype.forEach.call(panels_niv2,function(p){
            p.parentElement.classList.remove('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','false');
        });
        if(el.parentElement.classList.contains('side-panel__categ--is-open')){
            el.parentElement.classList.remove('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','false');
        }else{
            Array.prototype.forEach.call(panels,function(p){
                p.parentElement.classList.remove('side-panel__categ--is-open')
                el.setAttribute('aria-expanded','false');
            });
            el.parentElement.classList.add('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','true');
        }
        //el.parentElement.classList.toggle('side-panel__categ--is-open')
        window.setTimeout(act_sync_categories_to_list,30);
        window.setTimeout(act_sync_categories_to_list,60);
    });
})

Array.prototype.forEach.call(panels_niv2,function(el){
    // Premier Niveau
    el.addEventListener('click',function(){
        //console.log('niv2');
        if(el.parentElement.classList.contains('side-panel__categ--is-open')){
            el.parentElement.classList.remove('side-panel__categ--is-open');
            el.setAttribute('aria-expanded','false');
        }else{
            Array.prototype.forEach.call(panels_niv2,function(p){
                p.parentElement.classList.remove('side-panel__categ--is-open')
                el.setAttribute('aria-expanded','false');
            });
            el.parentElement.classList.add('side-panel__categ--is-open')
            el.setAttribute('aria-expanded','true');
        }
        //el.parentElement.classList.toggle('side-panel__categ--is-open')
        window.setTimeout(act_sync_categories_to_list,30);
        window.setTimeout(act_sync_categories_to_list,60);
    });
})

function act_sync_categories_to_list(){
    /*
    FP: Je sais c'est weird, je call 2x. Pour une raison quelconques desfois le sync retirait la catégorie qui venait d'être cliquée du select, peu importe on attendait combien de temps a passer.
    */
    const selects = document.getElementsByClassName('map-category-select');
    Array.prototype.forEach.call(selects,function(el){
        Array.prototype.forEach.call(el.options,function(option){
            //Essai de trouver la catégorie parmis les selects
            //if(option.value == categ){
                let ogValue = el.value;    
                let curEl = document.querySelector('[data-categ="'+option.value+'"]');
                if(curEl){
                    //console.log(curEl.parentElement.classList);
                    if(el.value.includes(option.value) && !curEl.parentElement.classList.contains('side-panel__categ--is-open')){
                        //console.log('sync did remove --- '+option.value);
                        ogValue.splice(ogValue.indexOf(option.value));
                    }
                    if(!el.value.includes(option.value) && curEl.parentElement.classList.contains('side-panel__categ--is-open')){
                        //console.log('sync did add --- '+option.value);
                        ogValue.push(option.value)
                    }
                }
                el.setValue(ogValue);
                optionIsInSelects = true;
            //}
            //console.log(el.value);
        })
    })
}